import { render } from "./GuestLayoutComponent.vue?vue&type=template&id=84c4a4bc"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__